<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-0">
    <!-- Loading State -->
    <div *ngIf="loading" class="col-span-full">
        <div class="flex items-center justify-center p-8">
            <app-loading-spinner message="Carregando estatísticas..."></app-loading-spinner>
        </div>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="flex items-center justify-center p-8">
        <div class="text-center text-danger">
            <div class="flex items-center gap-2 mb-4">
                <i class="ri-error-warning-line text-xl"></i>
                <p class="!mt-1">Erro ao carregar estatísticas</p>
            </div>
            <button class="ti-btn ti-btn-primary-full !py-1 !px-2 ti-btn-wave" (click)="loadStatistics()">
                <i class="ri-refresh-line"></i>
                Tentar Novamente
            </button>
        </div>
    </div>

    <!-- Statistics Cards -->
    <ng-container *ngIf="!loading && !error">
        <div *ngFor="let item of statsHome">
            <div class="box">
                <div class="box-body flex items-center justify-between !pb-[0.9rem]">
                    <div>
                        <p
                            class="!mb-2 text-[0.725rem] opacity-[0.7] text-[#8c9097] dark:text-white/50 font-semibold uppercase">
                            {{ item.title }}
                        </p>
                        <h5 class="font-semibold leading-none text-[1.25rem]">{{ item.value }}</h5>
                    </div>
                    <div
                        class="!text-primary flex items-center justify-center avatar avatar-md avatar-rounded bg-primary/10 !text-[20px]">
                        <i class="{{ item.icon }}"></i>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>